import React, { useRef } from 'react'
import fileImg from '../../../assets/img/file_image.png'
import { Box, Divider, Typography } from '@mui/material'
import { ReactComponent as Cross} from '../../../assets/icons/update_img_icons/cross.svg'
import { ReactComponent as FileIcon} from '../../../assets/icons/update_img_icons/File_Icon.svg'
import { usePermissions } from 'context/PermissionsContext'
import { findSpecificMenu, findSpecificSubMenu, isAllowed } from 'utils/checkUserRigths'


const FileContainerComp = ({
    fileheight,
    handleDrop,
    onClose,
    MissingHeaderText,
    handleFileChange,
    // onclick,
    // handleDragOver,
    // handleDragLeave,
    // dragging
}) => {
    const fileInputRef = useRef(null);
  
  const handleContainerClick = () => {
    fileInputRef.current.click();
  };


    return (
        <>
            <Box>
            { MissingHeaderText &&
                <Box sx={{display:'flex',justifyContent:'space-between', marginBottom:'12px'}}> 
                  <Typography
                    sx={{
                    fontFamily:'Poppins',
                    fontWeight:400,
                    fontSize:'20px',
                    lineHeight:'100%',
                    color:'white'
                    }}
                    >
                        {MissingHeaderText} 
                    </Typography>
                    <Box sx={{cursor:'pointer'}} onClick={onClose}>
                        <Cross />
                    </Box>
                </Box>
            }
            <Box
                 onDragOver={(e)=> e.preventDefault()}
                 onDrop={handleDrop}
                //  onDragLeave={handleDragLeave} 
                 className="fileContainer" sx={{ display: 'flex', height: fileheight, justifyContent: 'center', alignItems: 'center' }}  onClick={() =>handleContainerClick()}>
                <Box className="subFile" sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}>
                    {/* {!dragging&&
                    <>
                    </>
                    } */}
                    <Box>
                        <FileIcon />
                    </Box>
                    <Box  sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 'fit-content' }}>
                        <Typography className='fileContent' >Upload Images</Typography>
                        <Divider orientation="vertical" variant="middle" flexItem sx={{ backgroundColor: '#8B8B8B', height: '12px', width: '1px', marginX: 1 }} />

                        <Typography className='fileContent'>Drag & Drop</Typography>
                        <Divider orientation="vertical" variant="middle" flexItem sx={{ backgroundColor: '#8B8B8B', height: '12px', width: '1px', marginX: 1 }} />

                        <Typography className='fileContent'>Browse Files</Typography>
                    </Box>
                </Box>
            </Box>
            </Box>
            <input type="file" ref={fileInputRef} multiple accept="image/png, image/jpg, image/jpeg, image/webp" style={{ display: "none" }} onChange={handleFileChange} />
        </>
    )
}

export default FileContainerComp